{
    "ReportingMenu_FirstClosePopup": "Um das Menü erneut zu öffnen, klicken Sie auf der Berichtsseite in der Seitenleiste auf die Schaltfläche „Berichte“.",
    "NAME": "ReportingMenuLanguage"
}